import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-chat-report-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
  ],
  templateUrl: './chat-report-dialog.component.html',
  styleUrl: './chat-report-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatReportDialogComponent {
  public details = '';

  public constructor(private dialogRef: MatDialogRef<ChatReportDialogComponent>) {}

  public cancel(): void {
    this.dialogRef.close();
  }

  public report(): void {
    this.dialogRef.close(this.details);
  }
}
